import React, { useMemo } from "react";
var hypergeometric = require("@stdlib/stats-base-dists-hypergeometric");
import { Card, formatPercentage } from "@/components/Decklists/deckStatsLib";
import { IconTargetArrow } from "@tabler/icons-react";
import { getTheme } from "@/components/Decklists/barGraphTheme";
import { ResponsiveBar } from "@nivo/bar";
import { Progress } from "@heroui/react";

export function hyper(
  expected: number,
  hits: number,
  cardsToSearch: number,
): number {
  const cardsInDeck = 50;
  return hypergeometric.pmf(expected, cardsInDeck, hits, cardsToSearch);
}

export default function TriggerBodies({
  life,
  cardList,
}: {
  life: number | undefined;
  cardList: Card[];
}) {
  if (!life) {
    return <></>;
  }
  let triggerBodies = [];
  let hits = 0;
  const regex = /Play this card/i;
  for (const card of cardList) {
    if (card.data.power && card.data.power >= 5000) {
      const match = card.data.trigger && card.data.trigger.match(regex);
      if (match) {
        triggerBodies.push({
          id: card.id,
          count: card.count,
          name: card.data.name,
        });
        hits += card.count;
      }
    }
  }

  if (hits === 0) {
    return <></>;
  }

  let barGraphData = [];
  for (let i = life; i >= 0; i--) {
    barGraphData.push({
      bodies: i,
      probability: parseFloat((hyper(i, hits, life) * 100).toFixed(1)),
    });
  }

  let display = [];
  for (const item of barGraphData) {
    display.push(
      <div className="flex flex-row items-center gap-2" key={item.bodies}>
        <div className="w-[30px] text-center text-sm">{item.bodies}</div>
        <div className="w-[100px] text-center text-sm">{item.probability}%</div>
        <div className="w-full">
          <Progress
            size="sm"
            radius="sm"
            //   className={"col-span-3"}
            value={item.probability}
          />
        </div>
      </div>,
    );
  }

  //   <Progress
  //       size="sm"
  //       radius="sm"
  //       classNames={{
  //         base: "max-w-md",
  //         track: "drop-shadow-md border border-default",
  //         indicator: "bg-gradient-to-r from-pink-500 to-yellow-500",
  //         label: "tracking-wider font-medium text-default-600",
  //         value: "text-foreground/60",
  //       }}
  //       label="Lose weight"
  //       value={65}
  //       showValueLabel={true}
  //     />

  //   let display = [];
  //   display.push(
  //     <React.Fragment key="header">
  //       <div className="text-sm">Bodies in Life</div>
  //       <div className="text-sm">% Chance</div>
  //     </React.Fragment>,
  //   );
  //   for (let i = life; i >= 0; i--) {
  //     display.push(
  //       <React.Fragment key={i}>
  //         <div>{i}</div>
  //         <div>{formatPercentage(hyper(i, hits, life))}</div>
  //       </React.Fragment>,
  //     );
  //   }

  //   let display = [];
  //   display.push(
  //     <React.Fragment key="header">
  //       <div className="text-sm">Bodies in Life</div>
  //       <div className="text-sm">% Chance</div>
  //     </React.Fragment>,
  //   );
  //   for (let i = life; i >= 0; i--) {
  //     display.push(
  //       <React.Fragment key={i}>
  //         <div>{i}</div>
  //         <div>{formatPercentage(hyper(i, hits, life))}</div>
  //       </React.Fragment>,
  //     );
  //   }

  //   console.log(triggerBodies);

  return (
    <div className="bg-default-50 p-4 rounded-lg">
      <div className="mb-2">Trigger 5k+ Bodies</div>
      <div className="text-sm text-default-500 flex items-center gap-1 mb-2">
        <IconTargetArrow width={18} height={18} />
        Hits: {hits}
      </div>
      <div className="h-[70%] flex justify-center">
        <div className="flex flex-row items-center w-full">
          <div className="text-sm transform -rotate-90 whitespace-nowrap -ml-10 -mr-5">
            Bodies in Life
          </div>
          <div className="w-full flex flex-col gap-y-2">{display}</div>
        </div>
      </div>
    </div>
  );
}
